import React from 'react';
import styled from 'styled-components';

import { RewardBadgePill } from 'src/payments/components/reward-badge-pill/reward-badge-pill';

type PointsBoostBadgeProps = {
  // Display label from the points-boost foundation (e.g. "2x", "2.5x"); never a dollar amount.
  label: string;
};

export const PointsBoostBadge = ({ label }: PointsBoostBadgeProps): JSX.Element => (
  <Badge $prefix='pbb-points-boost' data-testid='pbb-points-boost-badge'>
    {label} points
  </Badge>
);

const Badge = styled(RewardBadgePill).withConfig({ componentId: 'pbb-points-boost-badge-pill' })``;
